export const manfaat = [
  {
    icon: `${process.env.CDN_URL}/images/main/mobile/manfaaticon1.webp`,
    message: `Meningkatkan efisiensi dalam produktivitas bisnis`,
  },
  {
    icon: `${process.env.CDN_URL}/images/main/mobile/manfaaticon2.webp`,
    message: `Meningkatkan volume bisnis`,
  },
  {
    icon: `${process.env.CDN_URL}/images/main/mobile/manfaaticon3.webp`,
    message: `Memberikan risk management yang lebih baik`,
  },
  {
    icon: `${process.env.CDN_URL}/images/main/mobile/manfaaticon4.webp`,
    message: `Memberikan rekomendasi yang presisi bagi nasabah`,
  },
];
